import { fetchAllTariffProducts } from 'Services/ProductManagement/Features/Product/productSlice'
import { getProductsInTariffParamKey } from 'Services/ProductManagement/Features/Product/utils'
import { useAppDispatch, useTypedSelector } from 'Store'
import { useEffect } from 'react'

function useTariffProducts(tariffId: string) {
  const dispatch = useAppDispatch()
  const { allTariffProducts, allTariffProductsLoading } = useTypedSelector(state => state.product)

  const fetchAllTariffProductsWithoutPagination = () => {
    dispatch(
      fetchAllTariffProducts({
        [getProductsInTariffParamKey()]: tariffId
      })
    )
  }

  useEffect(() => {
    fetchAllTariffProductsWithoutPagination()
  }, [])

  return {
    allTariffProducts,
    allTariffProductsLoading,
    fetchAllTariffProductsWithoutPagination
  }
}

export default useTariffProducts
